import CustomerId       from "../../../../domain/customer/CustomerId";
import CustomerIds      from "../../../../domain/customer/CustomerIds";
import MailGroup        from "../../../../domain/mail/group/MailGroup";
import MailGroupName    from "../../../../domain/mail/group/MailGroupName";
import ResKaReduxAction from "../../ResKaReduxAction";

export enum ACTION_TYPE {
  SET_MAIL_GROUP = "SET_MAIL_GROUP",
  SET_MAIL_GROUP_NAME = "SET_MAIL_GROUP_NAME",
  ADD_MAIL_GROUP_CUSTOMER = "ADD_MAIL_GROUP_CUSTOMER",
  ADD_ALL_MAIL_GROUP_CUSTOMER = "ADD_ALL_MAIL_GROUP_CUSTOMER",
  REMOVE_MAIL_GROUP_CUSTOMER = "REMOVE_MAIL_GROUP_CUSTOMER",
  REMOVE_ALL_MAIL_GROUP_CUSTOMER = "REMOVE_ALL_MAIL_GROUP_CUSTOMER",
}

export interface SetMailGroupAction extends ResKaReduxAction {
  mailGroup: MailGroup;
}

export interface SetMailGroupNameAction extends ResKaReduxAction {
  mailGroupName: MailGroupName;
}

export interface AddMailGroupCustomerAction extends ResKaReduxAction {
  customerId: CustomerId;
}

export interface AddAllMailGroupCustomerAction extends ResKaReduxAction {
  customerIds: CustomerIds;
}

export interface RemoveMailGroupCustomerAction extends ResKaReduxAction {
  customerId: CustomerId;
}

export interface RemoveAllMailGroupCustomerAction extends ResKaReduxAction {
}

export type MailGroupAction =
  SetMailGroupAction
  | SetMailGroupNameAction
  | AddMailGroupCustomerAction
  | AddAllMailGroupCustomerAction
  | RemoveMailGroupCustomerAction
  | RemoveAllMailGroupCustomerAction
  ;

export const setMailGroupAction = (mailGroup: MailGroup): SetMailGroupAction => ({
  type: ACTION_TYPE.SET_MAIL_GROUP,
  mailGroup: mailGroup,
});

export const setMailGroupNameAction = (mailGroupName: MailGroupName): SetMailGroupNameAction => ({
  type: ACTION_TYPE.SET_MAIL_GROUP_NAME,
  mailGroupName: mailGroupName,
});

export const addMailGroupCustomerAction = (customerId: CustomerId): AddMailGroupCustomerAction => ({
  type: ACTION_TYPE.ADD_MAIL_GROUP_CUSTOMER,
  customerId: customerId,
});

export const addAllMailGroupCustomerAction = (customerIds: CustomerIds): AddAllMailGroupCustomerAction => ({
  type: ACTION_TYPE.ADD_ALL_MAIL_GROUP_CUSTOMER,
  customerIds: customerIds,
});

export const removeMailGroupCustomerAction = (customerId: CustomerId): RemoveMailGroupCustomerAction => ({
  type: ACTION_TYPE.REMOVE_MAIL_GROUP_CUSTOMER,
  customerId: customerId,
});

export const removeAllMailGroupCustomerAction = (): RemoveAllMailGroupCustomerAction => ({
  type: ACTION_TYPE.REMOVE_ALL_MAIL_GROUP_CUSTOMER,
});